export default {"src":"/_next/static/media/calendar-outline.fdb2c0cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};